import React, { Component } from 'react'
import PropTypes from 'prop-types'
import YouTube from 'react-youtube'
import { isNil } from 'lodash'

import VideoPlayer from '../components/VideoPlayer'
import VideoMarkers from '../components/VideoMarkers'

function isYouTubeUrl(url) {
  const regExp = /^https?:\/\/(w{3}.)?youtu?.be/gm
  return !!(url && url.match(regExp))
}

// https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
function getYoutubeVideoId(url) {
  //eslint-disable-next-line
  var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/
  var match = url.match(regExp)
  return match && match[1].length == 11 ? match[1] : false
}

function isVimeoUrl(url) {
  const regExp = /^https?:\/\/(www\.)?(player\.)?vimeo\.com/gm
  return !!(url && url.match(regExp))
}

// Extract Vimeo video ID and optional unlisted hash from URL formats:
// - https://vimeo.com/123456789
// - https://vimeo.com/1162600617/3af9755072 (unlisted)
// - https://vimeo.com/1162600617?h=3af9755072 (unlisted)
// - https://player.vimeo.com/video/123456789
// - https://player.vimeo.com/video/1162600617?h=3af9755072 (unlisted)
function getVimeoEmbedParams(url) {
  const regExp = /vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)?(\d+)(?:\/([a-zA-Z0-9]+))?(?:[?#]\S*)?$/
  const match = url.match(regExp)
  if (!match) return null
  const queryHashMatch = url.match(/[?&]h=([a-zA-Z0-9]+)/)
  return {
    id: match[1],
    hash: match[2] || (queryHashMatch && queryHashMatch[1]) || null
  }
}

class TopicVideo extends Component {
  static propTypes = {
    video: PropTypes.object.isRequired,
    time: PropTypes.number,
    onVideoMarkerClick: PropTypes.func,
    onPlay: PropTypes.func,
  }

  render() {
    const { video, onVideoMarkerClick, time } = this.props

    const videoProps = {
      poster: video.thumbnailLink,
      autoplay: !!time, // enable autoplay when there is a time offset for video playback
      controls: true,
      playsinline: true,
      sources: [
        {
          src: video.externalLink,
          type: 'video/mp4',
        },
      ],
      time: time,
    }

    const youtubeVideoId = getYoutubeVideoId(video.externalLink)

    const renderVideoPlayer = () => {
      if (isYouTubeUrl(video.externalLink)) {
        return (
          <YouTube
            key={`youtube:${youtubeVideoId}:${time}`}
            opts={{
              playerVars: {
                rel: 0,
                start: time || 1,
                autoplay: isNil(time) ? 0 : 1
              }
            }}
            className='youtubeContainer'
            videoId={youtubeVideoId}
          />
        )
      }

      if (isVimeoUrl(video.externalLink)) {
        const vimeoParams = getVimeoEmbedParams(video.externalLink)
        if (!vimeoParams) return <VideoPlayer {...videoProps} onPlay={this.props.onPlay} />

        const query = new URLSearchParams({ autoplay: isNil(time) ? 0 : 1 })
        if (vimeoParams.hash) query.set('h', vimeoParams.hash)
        const vimeoEmbedUrl = `https://player.vimeo.com/video/${vimeoParams.id}?${query.toString()}${time ? `#t=${Math.floor(time)}` : ''}`

        return (
          <div key={`vimeo:${vimeoParams.id}:${vimeoParams.hash || ''}:${time}`} className='vimeoContainer'>
            <iframe
              src={vimeoEmbedUrl}
              title='Vimeo video player'
              frameBorder='0'
              allow='autoplay; fullscreen; picture-in-picture'
              allowFullScreen
            />
          </div>
        )
      }

      return <VideoPlayer {...videoProps} onPlay={this.props.onPlay} />
    }

    return (
      <div className='video-container'>
        <div className='video-player-container'>
          {renderVideoPlayer()}
        </div>
        {video.markers && (
          <VideoMarkers items={video.markers} onClick={t => onVideoMarkerClick && onVideoMarkerClick(t)} />
        )}
      </div>
    )
  }
}

export default TopicVideo